// removed by extract-text-webpack-plugin
module.exports = {"container":"_1D3B","defaultTint":"_1x_h","background":"_35q0","parallax":"_12Us","image":"_2XK5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/CaseStudySection/styles.scss
// module id = 416
// module chunks = 0